import { Field, ErrorMessage } from "formik";
import { get, set } from "lodash";
import { IMAGE_URL } from "../../config";
import { formatUnderscoreToSpace } from "../../utils/text-format";

export const FormMultiFileUploadField = ({
  label = "Upload Files",
  name = "files",
  labelClassName = "",
  className = "",
  previewClassName = "",
  accept = "*",
}) => {
  const handleFileChange = async (event, form, name) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    const uploaded = [];

    for (const file of files) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await fetch(IMAGE_URL, {
          method: "POST",
          body: formData,
        });

        if (response.status === 200) {
          const data = await response.json();
          const filePath = data?.data?.filePath;
          const fullUrl = filePath.startsWith("http")
            ? filePath
            : `https://api-new.requal.in${filePath}`;
          uploaded.push({ url: fullUrl, name: file.name });
        } else {
          console.error(`Upload failed: ${file.name}`);
          alert(`Failed to upload ${file.name}`);
        }
      } catch (err) {
        console.error(`Error uploading ${file.name}:`, err);
        alert(`An error occurred while uploading ${file.name}`);
      }
    }

    const currentFiles = get(form.values, name) || [];
    const updatedValues = { ...form.values };
    set(updatedValues, name, [...currentFiles, ...uploaded]);
    form.setValues(updatedValues);
  };

  const handleRemoveFile = (form, name, index) => {
    const files = get(form.values, name) || [];
    const updated = [...files.slice(0, index), ...files.slice(index + 1)];
    const updatedValues = { ...form.values };
    set(updatedValues, name, updated);
    form.setValues(updatedValues);
  };

  return (
    <Field name={name}>
      {({ form, meta }) => {
        const files = get(form.values, name) || [];
        const error = meta.touched && meta.error;

        return (
          <div className={`flex flex-col gap-1 ${className}`}>
            {label && (
              <label
                htmlFor={name}
                className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${
                  error ? "text-errorColor" : labelClassName
                }`}
              >
                {formatUnderscoreToSpace(label)}
              </label>
            )}

            <label className="cursor-pointer w-fit">
              <div
                className={`border-[1.5px] border-dashed rounded-md px-4 py-2 text-gray-600 hover:bg-gray-50 ${
                  error ? "border-errorColor" : "border-gray-400"
                }`}
              >
                Choose Files
              </div>
              <input
                type="file"
                accept={accept}
                multiple
                className="hidden"
                onChange={(event) => handleFileChange(event, form, name)}
              />
            </label>

            <div className={`flex flex-col gap-2 mt-2 ${previewClassName}`}>
              {files.map((file, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center bg-gray-50 p-2 rounded border"
                >
                  <span className="text-sm text-gray-800 truncate">
                    {file.name}
                  </span>
                  <button
                    type="button"
                    onClick={() => handleRemoveFile(form, name, index)}
                    className="ml-2 text-xs text-white bg-red-500 hover:bg-red-600 rounded px-2 py-0.5"
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>

            <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
              <ErrorMessage name={name} />
            </label>
          </div>
        );
      }}
    </Field>
  );
};
